import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import Week from './Week'
import css from './styles.css'

const Header = ({ date, handleChange }) => (
  <div className={css.header}>
    <div className={css.info}>
      <span className={css.month}>
        {date.format('MMM').toUpperCase()}
      </span>
    </div>
    <div className={css.info}>
      <span className={css.dayOfMonth}>
        {date.format('DD')}
      </span>
      <br />
      <span className={css.dayOfWeek}>
        {date.format('dddd').toUpperCase()}
      </span>
    </div>
    <Week date={date}>
      <DatePicker
        selected={date}
        onChange={handleChange}
      />
    </Week>
  </div>
)

Header.propTypes = {
  handleChange: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(moment),
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Schedule/Header/index.js